import { gql } from '@apollo/client';

const GET_USER = gql`
   query User {
      user {
         id
         externalId
         disableTracking
         email
         accessScope
      }
   }
`;

export default GET_USER;
